function Heading(props: Props) {
  switch (props.level) {
    case 1:
      return <h1>{props.data}</h1>
    case 2:
      return <h2>{props.data}</h2>
    case 3:
      return <h3>{props.data}</h3>
    case 4:
      return <h4>{props.data}</h4>
    case 5:
      return <h5>{props.data}</h5>
    case 6:
      return <h6>{props.data}</h6>
    default:
      return <h3>{props.data}</h3>
  }
}

export default Heading;

class Props {
  data: string;

  level: number;
}
